import SvgIcon, { SvgIconType, SvgIconSize } from './svg.icon';

export { SvgIconType, SvgIconSize };
export default SvgIcon;
